<template>
  <section class="projects_Container">
    <article
      v-for="project in projects"
      :key="project.id"
      class="project wow fadeInUp"
    >
      <div class="img_container wow zoomIn">
        <img
          :src="getImgUrl(project.headerImage)"
          :alt="project.title"
          loading="lazy"
          draggable="false"
        />
      </div>
      <div class="description_container wow fadeIn">
        <h3>{{ project.title }}</h3>
        <p>{{ project.description }}</p>
        <router-link :to="'/projects/' + project.id">
          <button class="wow zoomIn">
            {{ project.buttonText }}
          </button>
        </router-link>
      </div>
    </article>
    <WaveFooter />
  </section>
</template>

<script>
import WaveFooter from "@/components/WavFooter";
import { getImgUrl } from "@/util/methods";
export default {
  name: "Projects",
  components: {
    WaveFooter,
  },
  computed: {
    projects() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].projects.data;
    },
  },
  methods: {
    getImgUrl,
  },
};
</script>

<style></style>
